module.exports = __webpack_public_path__ + "static/media/bytt-no-5.027fb7fa.mp3";